import LoginButtonWrapper from './LoginButtonWrapper';

export default LoginButtonWrapper;
